<template>
	<div class="indicator-server-wrapper">
		<div class="net-indicator">
			<img v-if="connection || checkProcess" src="../assets/icon-wifi-fill.png" alt=""
				:class="{ process: checkProcess, connect: connection }">
			<img v-else src="../assets/icon-wifi-off-fill.png" alt="" :class="disconnect">
		</div>
	</div>
</template>

<script>
export default {
	name: 'check-server',
	props: {
		connection: {
			type: Boolean,
			default: false,
		},
		checkProcess: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		connetStatus() {
			if (this.checkProcess) {
				return 'проверка соединения'
			} else {
				return this.connection ? 'соединение установлено' : 'соединение потеряно'
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.indicator-server-wrapper {
	width: auto;
	height: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;

	&>* {
		flex: 0 1 auto;
	}

	.net-indicator {
		width: 24px;
		height: 24px;

		& img {
			width: 100%;
			height: 100%;

			&.process {
				animation-duration: .66s;
				animation-name: blink;
				animation-iteration-count: infinite;
			}
		}
	}

	.indicator-light {
		display: grid;
		grid-template-areas: "light";
		align-items: center;
		justify-content: center;
		width: 20px;

		&::before {
			content: '';
			grid-area: light;
			display: block;
			width: 14px;
			height: 14px;
			margin: 0 auto;
			border-radius: 50%;
			background-color: #fff;
		}

		&::after {
			content: '';
			grid-area: light;
			display: block;
			width: 10px;
			height: 10px;
			margin: 0 auto;
			border-radius: 50%;
			background-color: #fff;
			box-shadow: 0 0 5px #fff;
		}

		&.connect::after {
			background-color: #4a4;
			box-shadow: 0 0 5px #9f9;
		}

		&.disconnect::after {
			background-color: #a44;
			box-shadow: 0 0 5px #a44;
		}

		&.process::after {
			animation-duration: .66s;
			animation-name: blink;
			animation-iteration-count: infinite;
			// background-color: #fd8;
			// box-shadow: 0 0 5px #fd8;
		}
	}

	.indicator-status {
		color: #fff;
	}
}

@keyframes blink {
	from {
		opacity: 1;
	}

	50% {
		opacity: .5;
	}

	to {
		opacity: 1;
	}
}
</style>